import React, { useState } from 'react';

interface AppShellProps {
  rail: React.ReactNode;
  sidebar: React.ReactNode;
  main: React.ReactNode;
  rightPanel?: React.ReactNode;
  showRightPanel?: boolean;
}

export const AppShell: React.FC<AppShellProps> = ({ rail, sidebar, main, rightPanel, showRightPanel = false }) => (
  <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
    {/* Project Rail */}
    <div style={{ width: 64, background: 'var(--rail-bg)', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '12px 0', gap: 6 }}>
      {rail}
    </div>
    {/* Sidebar */}
    <div style={{ width: 240, background: 'var(--bg-sidebar)', borderRight: '1px solid var(--border)', flexShrink: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {sidebar}
    </div>
    {/* Main Content */}
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {main}
    </div>
    {/* Right Panel */}
    {showRightPanel && rightPanel && (
      <div style={{ width: 300, borderLeft: '1px solid var(--border)', background: 'white', flexShrink: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {rightPanel}
      </div>
    )}
  </div>
);
